import React from 'react';
import ErrorFallback from '../../Core/ErrorHandling/ErrorFallback';

const noop = () => {};

const NotFoundPage: React.FC = () => <ErrorFallback handleResetErrorState={noop} />;

export default NotFoundPage;
